import { authState } from '@/recoil/auth';
import { useRecoilValue } from 'recoil';

const useAuth = () => {
  const { token } = useRecoilValue(authState);
  return { token };
};

export default useAuth;
